/** Shared file-related display utilities. */

/** Format byte count as human-readable file size (e.g., "1.5 MB"). */
export function formatFileSize(bytes: number | null): string {
  if (bytes == null) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

/** Get short display label for a file type (MIME or extension). */
export function getFileTypeLabel(fileType: string | null): string {
  if (!fileType) return "";
  const lower = fileType.toLowerCase();
  if (lower.includes("pdf")) return "PDF";
  if (lower.includes("word") || lower.includes("doc")) return "DOC";
  if (lower.includes("excel") || lower.includes("sheet") || lower.includes("xls"))
    return "XLS";
  return "FILE";
}
